var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',_vm._g({},_vm.$listeners),[_c('font-awesome-icon',{staticClass:"w-5 h-5 pr-1",attrs:{"icon":['fa', 'plus'],"size":"lg"}}),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('add')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }